import router from "@/router/index";

import Auth from "../../apis/Auth";
import UsersApi from "../../apis/Users";
import ArrayTools from "../../helpers/ArrayTools";

let newInterval = null;
export default {
  namespaced: true,
  state: {
    token: null,
    select_office: false,
    user_companies: [],
    user_sedes: [],
    user_offices: [],
    office_id: null,
    current_employee: null,
    locked: false,
    auth_user: null,
    pin_unlock: null,
    company_id: null,
    sede_id: null,
    user_roles: null,
    till_user_id: null,
    user_permissions: [],
    wost_setting: null,
    office_login_name: null,
    show_menu: true,
    message_logout: null,
  },
  mutations: {
    set_show_menu(state, value) {
      state.show_menu = value;
    },
    set_current_employee(state, data) {
      state.current_employee = data;
    },
    set_token(state, token) {
      state.token = token;
    },
    set_select_office(state, select_office) {
      state.select_office = select_office;
    },
    set_user_companies(state, companies) {
      state.user_companies = companies;
    },
    set_user_sedes(state, user_sedes) {
      state.user_sedes = user_sedes;
    },
    set_user_offices(state, user_offices) {
      state.user_offices = user_offices;
    },
    set_office_id(state, office_id) {
      state.office_id = office_id;
    },
    set_locked(state, value) {
      state.locked = value;
    },
    set_auth_user(state, data) {
      state.auth_user = data;
    },
    set_pin_unlock(state, value) {
      state.pin_unlock = value;
    },
    set_company_id(state, value) {
      state.company_id = value;
    },
    set_sede_id(state, value) {
      state.sede_id = value;
    },
    set_user_roles(state, data) {
      state.user_roles = data;
    },
    set_till_user_id(state, value) {
      state.till_user_id = value;
    },
    set_user_permissions(state, data) {
      state.user_permissions = data;
    },
    set_wost_setting(state, data) {
      state.wost_setting = data;
    },
    set_office_login_name(state, value) {
      state.office_login_name = value;
    },
    set_message_logout(state, value) {
      state.message_logout = value;
    },
    set_login(state, data){
      state.token = data.set_token
      state.auth_user = data.set_auth_user
      state.select_office =data.set_select_office
      state.user_companies = data.set_user_companies
      state.user_sedes =data.set_user_sedes
      state.user_offices =data.set_user_offices
      state.current_employee = data.set_current_employee
      state.locked =data.set_locked
      state.pin_unlock =data.set_pin_unlock
      state.company_id =data.set_company_id
      state.sede_id = data.set_sede_id
      state.office_id = data.set_office_id
      state.user_roles = data.set_user_roles
      state.user_permissions = data.set_user_permissions
      state.till_user_id = data.set_till_user_id
      state.wost_setting = data.set_wost_setting
      state.office_login_name = data.set_office_login_name
    },
    set_logout(state, data){
      
      state.message_logout = data.set_message_logout
      state.token = data.set_token
      state.select_office =data.set_select_office
      state.current_employee = data.set_current_employee
      state.pin_unlock =data.set_pin_unlock
      state.till_user_id = data.set_till_user_id

    },
    set_change_office(state, data){
      state.company_id =data.set_company_id,
      state.sede_id = data.set_sede_id
      state.office_id = data.set_office_id
      state.till_user_id = data.set_till_user_id
      state.office_login_name = data.set_office_login_name
    }
  },
  actions: {
    setShowMenu({ commit }, value) {
      commit("set_show_menu", value);
    },
    run_set_locked({ commit }, value) {
      commit("set_locked", value);
    },
    async login({ commit, dispatch, state }, { username, password }) {
      let token_fcm = localStorage.getItem("token_fcm");
      return await Auth.login(username, password, token_fcm)
        .then((response) => {
          localStorage.setItem("access_token", "Bearer " + response.data.token);
          localStorage.setItem("access_date", Date.now());

          const data = {
            set_token: response.data.token,
            set_auth_user: response.data.user,
            set_select_office: response.data.select_office,
            set_user_companies: response.data.companies,
            set_user_sedes: response.data.sedes,
            set_user_offices: response.data.offices,
            set_current_employee: response.data.employee,
            set_locked: response.data.user.locked,
            set_pin_unlock: response.data.user.pin_unlock,
            set_company_id: response.data.company_id,
            set_sede_id: response.data.sede_id,
            set_office_id: response.data.office_id,
            set_user_roles: response.data.roles,
            set_user_permissions: response.data.permissions,
            set_till_user_id: response.data.till_user_id,
            set_wost_setting: response.data.wost_setting,
            set_office_login_name: response.data.office_login_name
          }

          commit("set_login", data);

          // commit("set_token", response.data.token);
          // commit("set_auth_user", response.data.user);
          // commit("set_select_office", response.data.select_office);
          // commit("set_user_companies", response.data.companies);
          // commit("set_user_sedes", response.data.sedes);
          // commit("set_user_offices", response.data.offices);
          // commit("set_current_employee", response.data.employee);
          // commit("set_locked", response.data.user.locked);
          // commit("set_pin_unlock", response.data.user.pin_unlock);
          // //datos de tienda
          // commit("set_company_id", response.data.company_id);
          // commit("set_sede_id", response.data.sede_id);
          // commit("set_office_id", response.data.office_id);
          // //roles y permisos
          // commit("set_user_roles", response.data.roles);
          // commit("set_user_permissions", response.data.permissions);
          // //caja de usuario
          // commit("set_till_user_id", response.data.till_user_id);
          // //configuraciones
          // commit("set_wost_setting", response.data.wost_setting);
          // commit("set_office_login_name", response.data.office_login_name);

          // this.interval('start')
          // startAlert()
          
          if (state.select_office) {
            router.push("/ingresar-sucursal");
          } else {
            router.push("/app/welcome");
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: error.response.data.message,
            },
            { root: true }
          );
        });
    },
    
    async set_office_login({ commit, dispatch }, office_id) {
      return await Auth.set_office_login(office_id)
        .then((response) => {
          const data = {
            set_company_id: response.data.company_id,
            set_sede_id: response.data.sede_id,
            set_office_id: response.data.office_id,
            set_till_user_id: response.data.till_user_id,
            set_office_login_name: response.data.office_login_name
          }
          commit('set_change_office', data)
          // commit("set_company_id", response.data.company_id);
          // commit("set_sede_id", response.data.sede_id);
          // commit("set_office_id", response.data.office_id);
          // //caja de usuario
          // commit("set_till_user_id", response.data.till_user_id);
          // commit("set_office_login_name", response.data.office_login_name);
          router.push("/app/welcome");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: error.response.data.error,
            },
            { root: true }
          );
        });
    },
    async lockSystem({ commit }, user) {
      return await UsersApi.lock(user)
        .then((response) => {
          commit("set_locked", response.data.locked);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          console.log(error);
        });
    },
    async logout({ commit, dispatch }) {
      return await Auth.logout()
        .then((reponse) => {
          localStorage.removeItem("token_fcm");
          localStorage.removeItem("access_token");
          const data = {
            set_message_logout: reponse.data.message,
            set_token: null,
            set_select_office: false,
            set_current_employee: null,
            set_pin_unlock: null,
            set_till_user_id: null
          }
          commit("set_logout", data);

          // commit("set_message_logout", reponse.data.message);
          // commit("set_token", null);
          // commit("set_select_office", false);
          // commit("set_current_employee", null);
          // commit("set_pin_unlock", null);
          // commit("set_till_user_id", null);
          // cancelAlert()
          router.push("/");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al cerrar sesión",
            },
            { root: true }
          );
        });
    },
    async logoutAux({commit, dispatch}){
      localStorage.removeItem('token_fcm');
      localStorage.removeItem('access_token')
      commit('set_token', null)
      commit('set_select_office', false)
      commit('set_current_employee', null);
      commit('set_pin_unlock', null);
      commit('set_till_user_id', null);
      dispatch('notifications/store_notification', {
          type: 'error',
          message: 'Sesion Expirada'
      }, {root: true});
      router.push('/');
},
     interval(type){
      setInterval(() => console.log("alerta actica cada 5 segundos"), 1000*5);
      // if(type == "end") this.borrarAlerta(newSetInterval);
    },
     initAlert(){
      console.log("alerta actica cada 5 segundos")
    },
     borrarAlerta(newSetInterval) {
      clearTimeout(newSetInterval);
    }
  },
  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },
    hasPermission: (state) => (permission) => {
      if (state.user_roles == "superadmin") {
        return true;
      } else {
        return state.user_permissions.includes(permission);
      }
    },
    hasMenu: (state) => (menu) => {
      if (state.user_roles == "superadmin") {
        return true;
      } else {
        return ArrayTools.existMenuInPermission(state.user_permissions, menu);
      }
    },
    getUserRole(state) {
      return state.user_roles;
    },
    isSuperadmin(state) {
      if (state.user_roles == "superadmin") {
        return true;
      } else {
        return false;
      }
    },
  },
};
